// extracted by mini-css-extract-plugin
export var dividerContainer = "_8q-0";
export var line = "_8q-1";